import React from 'react';

import SavedSearchesBar from 'src/common/ui/SavedSearchesBar';

import {
  getSavedTrackSearches,
  removeSavedTrackSearch,
  MAX_SAVED_TRACK_SEARCHES,
  SAVED_TRACK_SEARCHES_CHANGED,
  SavedTrackSearchState,
} from '../savedTrackSearchUtils';

interface SavedTrackSearchesBarProps {
  /** Applies a saved filter selection and re-runs the query. */
  readonly onLoadSearch: (state: SavedTrackSearchState) => void;
}

/** Track page's saved search chips. Presentation lives in the shared bar. */
const SavedTrackSearchesBar: React.FC<SavedTrackSearchesBarProps> = ({
  onLoadSearch,
}) => (
  <SavedSearchesBar<SavedTrackSearchState>
    getSearches={getSavedTrackSearches}
    removeSearch={removeSavedTrackSearch}
    changedEvent={SAVED_TRACK_SEARCHES_CHANGED}
    onLoadSearch={onLoadSearch}
    label="Saved Searches:"
    hint={`(max ${MAX_SAVED_TRACK_SEARCHES} — oldest removed automatically)`}
    itemTestId="saved-track-search"
  />
);

export default SavedTrackSearchesBar;
